import React from "react"
import { ISearchValue, SearchTypeEnum } from "../../../../components2/YhPageHeader/Types";
import { useHistoryModel } from "../dataHistoryModel"
import useMdmModel from "../../../../model/mdmModel"
import { YhPageHeader } from "../../../../components2/YhPageHeader";
export function SearchForm() {
    const {
        searchParam,
        upDataSearchParam,
        resetSearchParam,
        loadData
    } = useHistoryModel();
    const {mdmCatalog,mdmBranch} = useMdmModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "分支编码",
            fieldName: "branch",
            size: "small",
            disabled: false,
            options: mdmBranch
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "数据目录编码",
            fieldName: "catalog",
            size: "small",
            disabled: false,
            options: mdmCatalog
        },
        // {
        //     type: SearchTypeEnum.Input,
        //     span: 4,
        //     placeholder: "数据编码",
        //     fieldName: "dataCode",
        //     size: "small",
        //     disabled: false
        // },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            placeholder: "数据版本",
            fieldName: "dataVer",
            size: "small",
            disabled: false
        }
    ]
    return (
        <YhPageHeader
            title="历史版本列表"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={upDataSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    )
}